import { render, staticRenderFns } from "./FormulaE.vue?vue&type=template&id=96458ac0&scoped=true&"
import script from "./FormulaE.vue?vue&type=script&lang=js&"
export * from "./FormulaE.vue?vue&type=script&lang=js&"
import style0 from "./FormulaE.vue?vue&type=style&index=0&id=96458ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96458ac0",
  null
  
)

export default component.exports